import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {
    message: 'Chat với chúng tôi',
    isOpen: true,
    isChatOpen: false,
    minimize: true
  },
  initialize(o) {}
});
